import { render, staticRenderFns } from "./base-combobox.vue?vue&type=template&id=03cd0949&scoped=true&"
import script from "./base-combobox.vue?vue&type=script&lang=js&"
export * from "./base-combobox.vue?vue&type=script&lang=js&"
import style0 from "./base-combobox.vue?vue&type=style&index=0&id=03cd0949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd0949",
  null
  
)

export default component.exports